import apiClient from "./apiClient";
import { API_ROUTES } from "../config/baseURL";

export const getIndicadoresDashboard = async (filtros, seccion) => {
  const query = new URLSearchParams();

  if (seccion) query.append("seccion", seccion);

  Object.entries(filtros || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const normalized = Array.isArray(value) ? value.join(",") : String(value);
    if (normalized !== "") query.append(key, normalized);
  });

  const qs = query.toString();
  const url = qs ? `${API_ROUTES.dashboardIndicadores}?${qs}` : API_ROUTES.dashboardIndicadores;

  const res = await apiClient.get(url);
  return res.data;
};

export const getEpsDisponibles = async () => {
  const res = await apiClient.get(API_ROUTES.dashboardEps);
  return res.data;
};

export const getConfiguracionDashboard = async () => {
  const res = await apiClient.get(API_ROUTES.dashboardConfig);
  return res.data;
};

export const getCatalogoFiltro = async (idFiltro, params = {}) => {
  const query = new URLSearchParams({ idFiltro, ...params });
  const res = await apiClient.get(`${API_ROUTES.dashboardCatalogoFiltro}?${query.toString()}`);
  return res.data;
};
